import type { WebSocketStatus } from '@/hooks/useWebSocket';

export function shouldShowExtractionStatusPanel(
  status: WebSocketStatus,
  isPending: boolean,
  error?: string | null,
  manualError?: string | null,
): boolean {
  if (error || manualError) {
    return false;
  }

  if (isPending) {
    return true;
  }

  return status === 'connecting' || status === 'open';
}

export function isScreenshotLoadingState(
  isProcessing: boolean,
  screenshotUrl?: string | null,
): boolean {
  return Boolean(isProcessing && !screenshotUrl);
}
